<template>
  <div class="main">
    <el-row >
      <el-col :span="4">
        <ul class="list">
          <li v-for="(item,index) in list" :key="index"><router-link :to="item.url"><span class="col333">{{item.name}}</span> </router-link> </li>
        </ul>
      </el-col>
      <el-col :span="19" :offset="1" class="mart40">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { name: "走进我们", url: "/aboutus" },
        { name: "联系我们", url: "/aboutus" },
        { name: "加入我们", url: "/aboutus" },
        { name: "隐私申明", url: "/aboutus" },
        {name:'友情链接',url:'/aboutus'}
      ]
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style  lang="scss">
.main {
  width: 75rem;
  margin: auto;
}
.list {
  width: 200px;
  list-style: none;
  border-radius: 0.25rem;
  margin-top: 2.25rem;
}
.list li {
  width: 100%;
  height: 3.25rem;
  line-height: 3.25rem;
  background: #f0f0f0;
  color: #333;
  text-align: center;
  border-bottom: 0.125rem solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue